import React, { forwardRef, useEffect } from 'react'
import UserInfo from './UserInfo'
import Notifications from './Notifications'
import Btn from 'components/Btn'
import { useDispatch, useSelector } from 'react-redux'
import ClickAwayComponent from 'components/ClickAwayComponent'
import { setLoading, showSidebar, toggleSidebarCollapsed } from 'store/slices/miscSlice'
import { PanelLeft, Bell, CircleUserRound, ChevronDown } from 'lucide-react'
import useSWR from 'swr'

export default function Nav() {
  const { sidebar, sidebarCollapsed, navPageContext } = useSelector(state => state.misc)
  const { data: user } = useSWR('auth/me')
  const dispatch = useDispatch()
  const initials = user?.data?.first_name && user?.data?.last_name
    ? `${user.data.first_name[0]}${user.data.last_name[0]}`
    : null

  useEffect(() => {
    if (user) dispatch(setLoading('close'))
    else dispatch(setLoading())
  }, [user, dispatch])

  const toggleSidebar = () => {
    dispatch(!sidebar ? showSidebar() : showSidebar('close'))
    dispatch(toggleSidebarCollapsed())
  }

  return (
    <div className={`trans flex justify-between items-center h-16 px-4 bg-white border-b border-outline-variant z-10 fixed top-0 left-0 w-full ${sidebarCollapsed ? '' : 'lg:left-[272px] lg:w-[calc(100%-272px)]'}`}>
      <div className="flex items-center gap-1 min-w-0">
        <button
          type="button"
          onClick={toggleSidebar}
          className="p-2 rounded-md text-body-text hover:bg-input trans shrink-0"
        >
          <PanelLeft size={22} />
        </button>

        {
          navPageContext && (
            <button type="button" className="flex items-center gap-1.5 min-w-0 px-2 py-1 rounded-md hover:bg-input trans">
              <span className="min-w-0 text-left">
                <span className="block text-[11px] font-medium uppercase tracking-wide text-secondary">{navPageContext.eyebrow}</span>
                <span className="block text-sm font-semibold text-dark-blue truncate max-w-[240px]">{navPageContext.title}</span>
              </span>
              <ChevronDown size={16} className="text-secondary shrink-0" />
            </button>
          )
        }
      </div>

      <ul className="flex items-center">
        <ClickAwayComponent
          Component={forwardRef(({ handleClick, open }, ref) => <>
            <li className="inline-block mx-2 relative" ref={ref}>
              <Btn
                className="w-9 h-9 p-0 rounded-full flex items-center justify-center bg-surface-container-low hover:bg-surface-container"
                content={ () => <span className="relative inline-flex">
                    <Bell size={20} className="text-body-text" />
                    <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-danger border-2 border-surface-container-low" />
                  </span>
                }
                click={ handleClick }
              />

              {
                open && <Notifications handleClick={handleClick} />
              }
            </li>
          </>)
          }
        />

        <ClickAwayComponent
          Component={forwardRef(({ handleClick, open }, ref) => <>
            <li className="inline-block ml-2 relative" ref={ref}>
              <Btn
                className="w-9 h-9 p-0 rounded-full flex bg-transparent hover:bg-transparent overflow-hidden border border-outline-variant"
                content={ () => (
                  user?.data?.avatar ? (
                    <img src={user.data.avatar} alt="" className="w-9 h-9 rounded-full object-cover" />
                  ) : initials ? (
                    <span className="w-9 h-9 rounded-full bg-success flex items-center justify-center">
                      <span className="text-sm font-semibold text-white">{initials}</span>
                    </span>
                  ) : (
                    <span className="w-9 h-9 rounded-full bg-focus flex items-center justify-center">
                      <CircleUserRound size={22} className="text-primary" />
                    </span>
                  )
                )}
                click={ handleClick }
              />

              {
                open && <UserInfo user={user?.data} />
              }
            </li>
          </>)
          }
        />
      </ul>
    </div>
  )
}
